import { useState } from 'react'
import { GlassmorphicCard } from '@/components/ui/glassmorphic-card'
import { Megaphone, Bell, Calendar, User, Filter, MoreHorizontal } from 'lucide-react'
import { getBatches } from '@/data/mentor-mock-data'

export function MentorAnnouncementsView() {
    const batches = getBatches()
    const [selectedBatch, setSelectedBatch] = useState('all')

    // Mock Announcements Data
    const announcements = [
        {
            id: 1,
            title: 'Physics Chapter 4 Test Rescheduled',
            content: 'The Physics test scheduled for tomorrow has been moved to Monday due to the regional holiday. Please prepare accordingly.',
            author: 'Dr. Sarah',
            date: '2h ago',
            tags: ['Urgent', 'Schedule Change'],
            batch: 'NEET 2025 Batch A',
            readCount: 45
        },
        {
            id: 2,
            title: 'New Study Materials Available',
            content: 'Advanced problems for Organic Chemistry have been uploaded to the resources section. These are highly recommended for top rankers.',
            author: 'Dr. Sarah',
            date: '1d ago',
            tags: ['Resources', 'Chemistry'],
            batch: 'All Batches',
            readCount: 128
        },
        {
            id: 3,
            title: 'Weekend Doubt Clearing Session',
            content: 'A special doubt clearing session for Thermodynamics will be held this Saturday at 4 PM via Zoom.',
            author: 'Rahul Verma (Admin)',
            date: '2d ago',
            tags: ['Session', 'Physics'],
            batch: 'NEET 2025 Batch B',
            readCount: 42
        }
    ]

    return (
        <div className="space-y-6 pb-24 lg:pb-0">
            {/* Header */}
            <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                <div>
                    <h2 className="text-2xl font-bold text-theme-primary">Announcements</h2>
                    <p className="text-sm text-theme-secondary">Broadcast updates to your students</p>
                </div>
                <button className="px-4 py-2 bg-primary-blue text-white font-semibold rounded-lg hover:bg-blue-600 transition-colors flex items-center gap-2 shadow-lg shadow-blue-500/25">
                    <Megaphone className="h-4 w-4" />
                    Post Announcement
                </button>
            </div>

            {/* Filters */}
            <div className="flex gap-4 overflow-x-auto pb-2">
                <div className="flex items-center gap-2 px-3 py-2 bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700">
                    <Filter className="h-4 w-4 text-theme-secondary" />
                    <span className="text-sm font-medium text-theme-primary">Filter by:</span>
                </div>
                <select
                    value={selectedBatch}
                    onChange={(e) => setSelectedBatch(e.target.value)}
                    className="px-4 py-2 rounded-lg bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm outline-none"
                >
                    <option value="all">All Batches</option>
                    {batches.map(b => (
                        <option key={b} value={b}>{b}</option>
                    ))}
                </select>
                <button className="px-4 py-2 rounded-lg bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors">
                    Urgent Only
                </button>
            </div>

            {/* Announcements Feed */}
            <div className="space-y-4">
                {announcements.map((item) => (
                    <GlassmorphicCard key={item.id} className="p-6">
                        <div className="flex items-start justify-between">
                            <div className="flex gap-4">
                                <div className={`w-12 h-12 rounded-xl flex items-center justify-center shrink-0 ${item.tags.includes('Urgent') ? 'bg-red-100 dark:bg-red-900/20 text-red-600' : 'bg-blue-100 dark:bg-blue-900/20 text-blue-600'
                                    }`}>
                                    <Bell className="h-6 w-6" />
                                </div>
                                <div>
                                    <h3 className="text-lg font-bold text-theme-primary mb-1">{item.title}</h3>
                                    <p className="text-sm text-theme-secondary mb-3 leading-relaxed max-w-3xl">
                                        {item.content}
                                    </p>

                                    <div className="flex flex-wrap items-center gap-4 text-xs text-theme-secondary">
                                        <span className="flex items-center gap-1">
                                            <User className="h-3 w-3" />
                                            {item.author}
                                        </span>
                                        <span className="flex items-center gap-1">
                                            <Calendar className="h-3 w-3" />
                                            {item.date}
                                        </span>
                                        <span className="flex items-center gap-1">
                                            <Megaphone className="h-3 w-3" />
                                            {item.batch}
                                        </span>
                                        <span className="text-primary-blue font-medium">
                                            {item.readCount} read
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <button className="text-theme-secondary hover:text-theme-primary p-1">
                                <MoreHorizontal className="h-5 w-5" />
                            </button>
                        </div>

                        <div className="flex gap-2 mt-4 ml-16">
                            {item.tags.map(tag => (
                                <span key={tag} className="px-2 py-1 rounded text-[10px] font-bold uppercase tracking-wider bg-slate-100 dark:bg-slate-800 text-theme-secondary">
                                    {tag}
                                </span>
                            ))}
                        </div>
                    </GlassmorphicCard>
                ))}
            </div>
        </div>
    )
}
